import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import { SocketProvider } from './contexts/SocketContext';
import GlobalStyles from './styles/GlobalStyles';
import ProtectedRoute from './components/auth/ProtectedRoute';
import Layout from './components/common/Layout';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import DraftPage from './pages/DraftPage';
import TeamsPage from './pages/TeamsPage';
import AdminPage from './pages/AdminPage';
import AdminPicksPage from './pages/AdminPicksPage';
import ReportsPage from './pages/ReportsPage';
import DraftResultsPage from './pages/DraftResultsPage';

function App() {
  return (
    <Router>
      <GlobalStyles />
      <AuthProvider>
        <SocketProvider>
          <div className="App">
            <Routes>
              {/* Public routes */}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              
              {/* Protected routes */}
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <DashboardPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/draft"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <DraftPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/draft/:draftId"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <DraftPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/teams"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <TeamsPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/reports"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <ReportsPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/draft/:draftId/results"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <DraftResultsPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute adminOnly>
                    <Layout>
                      <AdminPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/picks"
                element={
                  <ProtectedRoute adminOnly>
                    <Layout>
                      <AdminPicksPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              
              {/* Catch all route */}
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>

            {/* Toast notifications */}
            <Toaster
              position="top-right"
              toastOptions={{
                duration: 4000,
                                 style: {
                   background: '#000000',
                   color: '#FFFFFF',
                   border: '1px solid #252525',
                 },
                success: {
                  iconTheme: {
                    primary: '#00FF41',
                    secondary: '#000000',
                  },
                },
                error: {
                  iconTheme: {
                    primary: '#EF4444',
                    secondary: '#FFFFFF',
                  },
                },
              }}
            />
          </div>
        </SocketProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
